"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostSupervisor = void 0;
const tslib_1 = require("tslib");
const state_flow_1 = require("@video/state-flow");
const bind_1 = require("../../internal/utils/bind");
const common_1 = require("./drivers/video-element/common");
const Host = tslib_1.__importStar(require("./state-flow/manifest/host"));
const Playback = tslib_1.__importStar(require("./state-flow/controls/playback"));
const pile = new WeakSet();
const videoElementEvents = new Map([
    ["play", "onPlay"],
    ["pause", "onPause"],
    ["loadeddata", "onLoadedData"],
    ["loadedmetadata", "onLoadedMetaData"],
    ["canplay", "onCanPlay"],
    ["error", "onError"],
    ["suspend", "onSuspend"],
    ["volumechange", "onVolumeChange"],
    ["abort", "onAbort"],
    ["emptied", "onEmptied"],
    ["ended", "onEnded"],
    ["playing", "onPlaying"],
    ["stalled", "onStalled"],
    ["waiting", "onWaiting"],
]);
class HostSupervisor {
    // private callDepth = 0;
    // private stack = new DisposableStack();
    // private stopListenersCallbacks: (() => void)[] = [];
    constructor(ctx) {
        this.ctx = ctx;
        (0, bind_1.makeBounded)(this);
        this.init();
    }
    init() {
        // this.wrapEnterState(Audio.Muted, this.handleUnMuted);
        // this.wrapEnterState(Audio.UnMuted, this.handleMuted);
        // this.wrapEnterState(MediaElement.HaveNothing, this.handleAttached);
        // this.addHandler(ForcedMute, this.mutedHandler);
        // this.addHandler(Attached, this.attachedHandler);
        // this.addHandler(Detached, this.detachedHandler);
        // this.addHandler(Playing, this.playingHandler);
        // init drivers
    }
    initStateFlow(sf) {
        this.sf = sf;
        sf.handleEnter(Host.Attached, this.hostAttached);
        sf.handleExit(Host.Attached, this.hostDetached);
        // this.sf = sf;
        // sf.handleEnter(Audio.Muted, this.handleMuted);
        //
        // sf.handleEnter(Host.Attached, this.hostAttached);
        // sf.handleEnter(Host.Detached, this.hostDetached);
    }
    hostAttached(states) {
        const el = states.host.element;
        if (!(0, common_1.isVideoElement)(el)) {
            return state_flow_1.Result.ignore("not a video element");
        }
        if (pile.has(el)) {
            return state_flow_1.Result.reject("video element is already attached to another player");
        }
        pile.add(el);
        for (const [key, value] of videoElementEvents.entries()) {
            el.addEventListener(key, this[value]);
        }
        return state_flow_1.Result.ok();
    }
    onWaiting() {
        // console.log("!!! el waiting");
    }
    onStalled() {
        // console.log("!!! el stalled");
    }
    onPlaying() {
        console.log("!!! el playing");
    }
    onEnded() {
        // console.log("!!! el ended");
    }
    onEmptied() {
        // console.log("!!! el emptied");
    }
    onAbort() {
        console.log("!!! el abort");
    }
    onVolumeChange() {
        const el = (0, common_1.getVideoElement)(this.sf.host.element);
        const volumeChanged = (0, common_1.isVolumeChanged)(el.volume, this.sf.audio.volume);
        if (volumeChanged && !(0, state_flow_1.isTransitioning)(this.sf)) {
            this.sf.dispatch("uncontrolledVolumeChange", { volume: el.volume });
        }
    }
    onSuspend() {
        // console.log("!!! el suspend");
    }
    onError() {
        console.log("!!! el error");
    }
    onCanPlay() {
        // console.log("!!! el can play");
    }
    onLoadedMetaData() {
        // console.log("!!! el loaded meta data");
    }
    onLoadedData() {
        // console.log("!!! el loaded data");
    }
    onPause() {
        if (Playback.Playing.is(this.sf.playback) && !(0, state_flow_1.isTransitioning)(this.sf)) {
            this.sf.dispatch("uncontrolledPause", {});
        }
    }
    onPlay() {
        if (!Playback.Playing.is(this.sf.playback) && !(0, state_flow_1.isTransitioning)(this.sf)) {
            this.sf.dispatch("uncontrolledPlay", {});
        }
    }
    hostDetached({ host }) {
        const el = host.element;
        if (!(0, common_1.isVideoElement)(el)) {
            return state_flow_1.Result.ignore("not a video element");
        }
        this.removeElListeners(el);
        pile.delete(host.element);
        return state_flow_1.Result.ok();
    }
    [Symbol.dispose]() {
        const el = this.sf.host.element;
        if ((0, common_1.isVideoElement)(el)) {
            this.removeElListeners(el);
            pile.delete(el);
        }
    }
    initElListeners() {
        // this.addGenericElListener("canplay", "externalCanPlay");
        // this.addGenericElListener("play", "externalPlay");
        // this.addGenericElListener("pause", "externalPause");
        // this.addGenericElListener("volumechange", "externalVolumeChange");
    }
    //
    // private wrapEnterState<Props>(state: StateType<Props>, cb: FeedbackCallback<Props>): void {
    //   const wrapper = (newState: StateType<Props>, oldState: StateType<Props>, group: string): Result => {
    //     try {
    //       this.callDepth++;
    //       return cb(newState, oldState, group);
    //     } finally {
    //       this.callDepth--;
    //     }
    //   };
    //
    //   this.disposableStack.defer(
    //     this.sm.handleEnter(state, wrapper),
    //   );
    // }
    //
    // private wrapExitState<Props>(state: StateType<Props>, cb: FeedbackCallback<Props>): void {
    //   const wrapper = (newState: StateType<Props>, oldState: StateType<Props>, group: string): Result => {
    //     try {
    //       this.callDepth++;
    //       return cb(newState, oldState, group);
    //     } finally {
    //       this.callDepth--;
    //     }
    //   };
    //
    //   this.disposableStack.defer(
    //     this.sm.handleExit(state, wrapper),
    //   );
    // }
    //
    // private addGenericElListener<K extends keyof VideoElementEventsMap, S extends keyof Signals>(type: K, signal: S) {
    //   if (!isExternalSignal(signal)) {
    //     throw new Error("Not an external signal");
    //   }
    //
    //   this.addElListener(type, () => {
    //     if (this.el != null) {
    //       this.sm.dispatch(signal, { el: this.el });
    //     }
    //   });
    // }
    //
    // private addElListener<K extends keyof VideoElementEventsMap>(type: K, cb: (ev: VideoElementEventsMap[K]) => void) {
    //   if (this.el == null) {
    //     throw new Error("No host element");
    //   }
    //
    //   this.el.addEventListener(type, cb);
    //   this.stopListenersCallbacks.push(() => this.el?.removeEventListener(type, cb));
    // }
    //
    // private handleUnMuted(newState: State<Audio.Props>, oldState: State<Audio.Props>): Result {
    //   if (this.el == null) {
    //     return IgnoredNoHostElement;
    //   }
    //
    //   if (newState.volume === this.el.volume && !this.el.muted) {
    //     return Result.ignore("Already unmuted");
    //   }
    //
    //   this.el.volume = newState.volume;
    //   this.el.muted = false;
    //   return Result.ok();
    // };
    //
    // private handleMuted(newState: State<Audio.Props>, oldState: State<Audio.Props>): Result {
    //   if (this.driver == null) {
    //     return IgnoredNoDriver;
    //   }
    //
    //   if (this.driver.muted) {
    //     return Result.ignore("Already muted");
    //   }
    //
    //   this.driver.muted = true;
    //   return Result.ok();
    // };
    //
    // private handleAttached(state: State<MediaElement.Props>): Result {
    //   if (this.el != null) {
    //     return Result.reject("Host element already attached");
    //   }
    //
    //   this.el = state.host;
    //   this.initElListeners();
    //
    //   return Result.ok();
    // };
    //
    // private detachedHandler: WatcherCallback<PlayerStateFlow, "mediaElement"> = () => {
    //   if (this.el == null) {
    //     return SignalResult.Ignored;
    //   }
    //
    //   this.removeElListeners();
    //   this.el = null;
    //
    //   return SignalResult.Handled;
    // };
    //
    // private playingHandler: WatcherCallback<PlayerStateFlow, "playing"> = () => {
    //   if (this.el == null) {
    //     return IgnoredNoHostElement;
    //   }
    //
    //   if (!this.el.paused) {
    //     return StateResult.ignored("Already playing");
    //   }
    //
    //   return StateResult.inTransition(this.el.play().then(() => {
    //     return StateResult.handled();
    //   }));
    // };
    removeElListeners(el) {
        for (const [key, value] of videoElementEvents.entries()) {
            el.removeEventListener(key, this[value]);
        }
    }
}
exports.HostSupervisor = HostSupervisor;
HostSupervisor.displayName = "HostSupervisor";
//
// export type MediaElementProxyHandlerEvents = {
//   getter: { property: string, value: any };
//   setter: { property: string, value: any };
//   callStarted: { method: string; args: any[] };
//   callEnded: { method: string; args: any[]; result: any };
//   callResolved: { method: string; args: any[]; result: any };
// };
//
// class MediaElementProxyHandler extends ObservableEventEmitter<MediaElementProxyHandlerEvents> implements ProxyHandler<VideoElement> {
//   denyListProperties = new Set<string>(["getAttribute", "setAttribute", "addEventListener", "removeEventListener"]);
//
//   constructor(private debug = false) {
//     super();
//   }
//
//   get(target: VideoElement, p: string | symbol, receiver: any): any {
//     if (!this.debug) {
//       return Reflect.get(target, p);
//     }
//
//     const value = Reflect.get(target, p);
//     if (typeof value === 'function') {
//       return (...args: any[]) => {
//         if (!this.denyListProperties.has(String(p))) {
//           this.emit("callStarted", { method: String(p), args });
//         }
//
//         const result = value.apply(target, args);
//         if (!this.denyListProperties.has(String(p))) {
//           this.emit("callEnded", { method: String(p), args, result });
//         }
//
//         if ("then" in value && typeof value.then === "function") {
//           value.then((result: any) => {
//             this.emit("callResolved", { method: String(p), args, result });
//           });
//         }
//         return result
//       }
//     } else {
//       this.emit("getter", { property: String(p), value });
//     }
//     return value;
//   }
//
//   set(target: VideoElement, p: string | symbol, newValue: any, receiver: any): boolean {
//     if (!this.debug) {
//       return Reflect.set(target, p, newValue);
//     }
//
//     this.emit("setter", { property: String(p), value: newValue });
//
//     return Reflect.set(target, p, newValue);
//   }
// }
//# sourceMappingURL=host-supervisor.js.map